<template>
    <!-- 결제정보 자동 등록 팝업 -->
    <div v-show='show' class='layer-pop square-type'>
        <div class='view-content' style='width: 640px;'>
            <button class='close' @click='onClosePop'><span class='blind'>팝업 닫기</span></button>
            <div class="px-6">
              <p class='sub-title mb-4'>통장 사본</p>
            </div>
            
            <div class="px-6">
              <div class='scroll-area com-scroll-y img_area'>
                <img v-if="!!imageUrl" :src='imageUrl'>
              </div>
            </div>

            <div class='bottom-btn mt-8'>
              <button class="com-btn" @click="onDownload">다운로드</button>
            </div>
        </div>
    </div>
</template>

<script>
import LoadingSpinner from '@/components/LoadingSpinner';

export default {
  name: 'BankbookConfirmDlg',
  components: { LoadingSpinner },
  props: {
    imageUrl: String,
    downloadName: String,
    show: Boolean,
    close: Function,
  },
  data() {
    return {
      loading: false,
      requestList: [],
      selectedId: null,
      searchKeyword: '',
      pagingInfo: {
        page: 1, // 페이지
        limit: 5, // 한 목록에 표출되는 건수
        totalItems: '', // 총 Item 수
        itemCount: '', // 현재 페이지 item 수
        totalPages: '', // 총 페이지 수
        route: '', // 링크 경로 생성시 프리픽스
      }
    };
  },
  methods: {
    init(){

    },

    onClosePop() {
      this.close();
    },

    async onDownload(e){
      e.stopPropagation();
      e.preventDefault();
      console.log(this.imageUrl, this.downloadName)
      if(!this.imageUrl || !this.downloadName) return

      const source = await fetch(this.imageUrl)
      if(!source.ok) return;

      try {
        const blob = await source.blob();
        const sourceUrl = URL.createObjectURL(blob);

        const link = document.createElement('a')
        link.href = sourceUrl
        link.download = this.downloadName || '통장사본';
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)  
      } catch (error) {
        console.log(error);
      }
      
    },
  },
};
</script>
<style scoped>
  .img_area{
    max-height: 320px;
    min-height: 200px;
    background-color: #F1F5F7;
    border: 1px solid #CED4DA;

    img{
      max-width: 100%;
      width: 100%;
    }
  }
</style>
